import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTotal } from 'src/features/common/explore/hooks/use-explore-launchpads';
import { useProfile } from 'src/features/common/profile/hooks/profile.hooks';
import { usePublicProfile } from 'src/features/common/profile/hooks/public-profile.hooks';
import { EmptyListPlaceholder } from 'src/features/common/shared/components/empty-list-placeholder';
import { LaunchpadsContainer } from 'src/features/white-labels/ocean/explore/containers/launchpads-container';
import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { Spacing } from 'src/ui/common/atoms/spacing';
import { Typography } from 'src/ui/common/atoms/typography';

export const ProfileLaunchpadsContainer = () => {
    const { t } = useTranslation(['components']);
    const total = useTotal();
    const profile = useProfile();
    const publicProfile = usePublicProfile();

    const profileOwner = (profile && profile.user.login) === publicProfile?.login;

    if (!total) {
        return (
            <EmptyListPlaceholder itemsGridConfig={{ xs: 1, sm: 2, md: 3, lg: 3, xl: 4 }}>
                <FlexBox flexDirection="column" alignItems="center">
                    <Spacing mb="10px">
                        <Typography variant="title" size="base" color="white">
                            {t(`emptyList.launchpad.title.${profileOwner ? 'private' : 'public'}`)}
                        </Typography>
                    </Spacing>
                    <Typography>{t(`emptyList.launchpad.subtitle.${profileOwner ? 'private' : 'public'}`)}</Typography>
                </FlexBox>
            </EmptyListPlaceholder>
        );
    }

    return <LaunchpadsContainer />;
};
